// This function makes it so that forms that have the class auto-submit-form
// use the rails ajax form submit whenever any input in the form is clicked.
// used currently for the companies and jobs filter forms.
import $ from 'jquery';

function bindAutoSubmitForms() {
  function showLoading(form) {
    // Show the loading animation as soon as the user starts typing
    var loading_id = form.data('loadingAnimation');
    if(loading_id != null) {
      $(loading_id + "-loading").show();
      $(loading_id).hide();
    }
  }

  function submitForm(form) {
    form.find('input[name=page]').val(''); // Paginate back to page 1
    showLoading(form);
    form.trigger('submit.rails');
  }

  $('form[data-auto-submit="true"]').each(function() {
    var form = $(this);
    form.find('input[type=radio]').click(function() { submitForm(form) });
    form.find('input[type=checkbox]').click(function() { submitForm(form) });
    form.find('select').change(function() { submitForm(form) });
    // If this is an input text box then delay 200ms before submitting the form
    form.find('input[type=search]').keyup(function() {
      form.find('input[name=page]').val(''); // Paginate back to page 1
      showLoading(form);
      clearTimeout(form.data('timeout'));
      form.data('timeout', setTimeout(function() {
         form.trigger('submit.rails');
      }, 200));
    });

    var inputPrevVal = null;

    var textSubmit = function(event) {
      if ($(event.target).data('cancel-autosubmit')) { return };
      var currentVal = $(event.target).val();
      if (currentVal == inputPrevVal){ return }; // this doesn't work quite right - shared "prevVal" across all text inputs makes no sense

      form.find('input[name=page]').val(''); // Paginate back to page 1
      showLoading(form);
      clearTimeout(form.data('timeout'));
      form.data('timeout', setTimeout(function() {
         form.trigger('submit.rails');
      }, 500));
      inputPrevVal = currentVal;
    };

    form.find('input[type=text]').keyup(function(event) {
      if($(event.target).data("datepicker")) { return };
      textSubmit(event);
    });

    form.find('input[type=text]').on("sz-search", textSubmit);

    form.find('[data-autocomplete]').on('selected.autocomplete', function() {
      submitForm(form);
    });
  });
}

$(document).ready(function() {
  bindAutoSubmitForms();
});
